"use client";
import Button from "@/components/ui/Button";
import { InputField } from "@/components/ui/Input";
import { useTranslations } from "@/i18n/client";
import { useValidation } from "@/lib/centra/hooks/useValidation";
import { useSelection, useUpdateUser } from "@frend-digital/centra/client";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useRef } from "react";
import { FormProvider, useForm } from "react-hook-form";
import styles from "./index.module.css";

const AccountInfoForm = () => {
  const validation = useValidation();
  const selection = useSelection();
  const user = selection.data?.loggedIn;

  const schema = validation
    .object({
      firstName: validation.string().required(),
      lastName: validation.string().required(),
      email: validation.string().email().optional(),
      phoneNumber: validation.string().optional(),
    })
    .required();

  const form = useForm({
    resolver: yupResolver(schema),
  });

  const hasDefaults = useRef(false);

  const { handleSubmit, setValue } = form;

  const updateUser = useUpdateUser();

  const onSubmit = handleSubmit(({ firstName, lastName, phoneNumber }) => {
    updateUser.mutate({ firstName, lastName, phoneNumber });
  });

  useEffect(() => {
    if (!user || hasDefaults.current) return;

    hasDefaults.current = true;
    user.firstName && setValue("firstName", user.firstName);
    user.lastName && setValue("lastName", user.lastName);
    user.email && setValue("email", user.email);
    user.phoneNumber && setValue("phoneNumber", user.phoneNumber);
  }, [user, setValue]);

  const t = useTranslations();

  return (
    <>
      <FormProvider {...form}>
        <form className={styles.accountForm} onSubmit={onSubmit}>
          <InputField
            placeholder="add name"
            name="firstName"
            label={t("myAccount.accountPage.accountInfo.firstName")}
          />
          <InputField
            placeholder="add last name"
            type="text"
            label={t("myAccount.accountPage.accountInfo.lastName")}
            name="lastName"
          />
          <InputField
            placeholder="add email"
            type="email"
            label={t("myAccount.accountPage.accountInfo.email")}
            name="email"
          />
          <InputField
            placeholder="add phone number"
            type="tel"
            label={t("myAccount.accountPage.accountInfo.phone")}
            name="phoneNumber"
          />
          <Button isLoading={updateUser.isPending} type="submit">
            {t("myAccount.accountPage.accountInfo.updateButton")}
          </Button>
        </form>
      </FormProvider>
    </>
  );
};

export default AccountInfoForm;
